/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button, Col, Space, TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { DateTimeFormatSimple } from '../../models/datetime'
import { Dimen } from '../../models/dimen'
import { getStandStateName } from '../../models/standbook'

export const Columns = (): TableColumnType<any>[] => {
  return [
    {
      title: '就诊信息',
      align: 'left',
      dataIndex: '',
      width: Dimen.Sex,
      render: (_, t) => {
        return (
          <>
            <div>就诊日期 ： {t?.registrationTime}</div>
            <div>挂号医生 ：{t?.registrationDoctorName}</div>
            <div>接诊医生 ： {t?.treatmentDoctorName}</div>
            <div>疾病名称 ： </div>
            <div>费用金额 ： {t?.amount}</div>
          </>
        )
      },
    },
  ]
}


export const ColumnsTwo = (): TableColumnType<any>[] => {
  return [
    {
      title: '用药/治疗',
      align: 'center',
      dataIndex: 'companyCode',
      width: Dimen.Sex,
      render: (_, t) => {
        return moment(t.happenTime ? t.happenTime : undefined).format(
          DateTimeFormatSimple
        )
      },
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'licenceCategory',
      width: Dimen.Sex,
      render: (_, t) => {
        return moment(t.pullTime ? t.pullTime : undefined).format(
          DateTimeFormatSimple
        )
      },
    },
    {
      title: '剂型',
      align: 'center',
      dataIndex: 'supplierCategory',
      width: Dimen.Sex,
      render: (_, t) => {
        return getStandStateName(t.state)
      },
    },
    {
      title: '单位',
      align: 'center',
      width: '10rem',
      dataIndex: 'reason',
      render: (_, t) => {
        return (
          <p
            style={{
              textAlign: 'center',
              maxWidth: '240px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: '0 auto',
            }}
          >
            {t.reason}
          </p>
        )
      },
    },
    {
      title: '数量',
      align: 'center',
      width: '10rem',
      dataIndex: 'reason',
      render: (_, t) => {
        return (
          <p
            style={{
              textAlign: 'center',
              maxWidth: '240px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: '0 auto',
            }}
          >
            {t.reason}
          </p>
        )
      },
    },
    {
      title: '频次',
      align: 'center',
      width: '10rem',
      dataIndex: 'reason',
      render: (_, t) => {
        return (
          <p
            style={{
              textAlign: 'center',
              maxWidth: '240px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: '0 auto',
            }}
          >
            {t.reason}
          </p>
        )
      },
    },
    {
      title: '用法',
      align: 'center',
      width: '10rem',
      dataIndex: 'reason',
      render: (_, t) => {
        return (
          <p
            style={{
              textAlign: 'center',
              maxWidth: '240px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: '0 auto',
            }}
          >
            {t.reason}
          </p>
        )
      },
    },
    {
      title: '每次用量',
      align: 'center',
      width: '10rem',
      dataIndex: 'reason',
      render: (_, t) => {
        return (
          <p
            style={{
              textAlign: 'center',
              maxWidth: '240px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              margin: '0 auto',
            }}
          >
            {t.reason}
          </p>
        )
      },
    },
  ]
}

export const QuantitiesColumns = ( startIndex: number,isClassifiedByDiseaseChecked?: any): TableColumnType<any>[] => {

  const column: TableColumnType<any>[] = [
    {
      title: "序号",
      key: "no",
      align: "center",
      width: "4rem",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '主要诊断',
      dataIndex: 'mainDisease',
      width: '100px',
      align: 'left',
      ellipsis: true,
      key: 'mainDisease',
      render: (_, r) => {
        return r?.mainDisease || '-'
      },
    },
    {
      title: '商品信息',
      // fixed: "left",
      align: 'center',
      width: '300px',
      dataIndex: 'name',
      ellipsis: true,
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '470px',
      ellipsis: true,
    },
    {
      title: '总数量',
      align: 'center',
      dataIndex: 'counts',
      width: Dimen.Sex,
    },
  ]
  return isClassifiedByDiseaseChecked ? column : column?.filter((item) => item.key != 'mainDisease')

}

